export default [
  {
    path: "/mendian/mendian/:id",
    name: "Mendian",
    meta: {
      title: "门店详情",
      keepAlive: false
    },
    component: () => import("@views/mendian/mendian.vue")
  }
];
